import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    FontIcon,
    Menu,
    MenuItem,
    MuiThemeProvider,
    Popover
} from "material-ui-old";
import { greyPalette } from "../../helpers/constants/colorPalettes";

class UserAccountMenu extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isMenuOpen: false,
            anchorEl: null
        };

        this.styles = {
            button: {
                color: greyPalette.white
            },

            menu: {
                width: "182px"
            },

            list: {
                backgroundColor: "#59c7fa"
            },

            menuItem: {
                color: greyPalette.white,
                fontSize: "14px"
            },
            menuItemIcon: {
                color: greyPalette.white,
                fontSize: "12px",
                paddingTop: "6px"
            }
        };
    }

    componentDidMount() {
        // nothing yet
    }

    componentWillReceiveProps(nextProps) {
        // nothing yet
    }

    handleTouchTap = event => {
        event.preventDefault();

        this.setState({
            isMenuOpen: true,
            anchorEl: event.currentTarget
        });
    };

    handleRequestClose = () => {
        this.setState({
            isMenuOpen: false,
            anchorEl: null
        });
    };

    onTouchTap(func) {
        // Closes menu before performing specified function
        this.handleRequestClose();
        func();
    }

    render() {
        return (
            <MuiThemeProvider>
                <div className={this.props.className}>
                    <div
                        onClick={this.handleTouchTap}
                        style={this.styles.button}
                    >
                        <FontAwesomeIcon
                            icon="user"
                            style={{ marginRight: 5 }}
                        />
                        <span style={{ paddingRight: 5 }}>
                            {" "}
                            Hi, {this.props.user.firstName}
                        </span>
                        <FontAwesomeIcon
                            icon={["fal", "angle-down"]}
                            style={{ marginRight: 5 }}
                        />
                    </div>
                    <Popover
                        zDepth={0}
                        open={this.state.isMenuOpen}
                        anchorEl={this.state.anchorEl}
                        anchorOrigin={{
                            horizontal: "right",
                            vertical: "bottom"
                        }}
                        targetOrigin={{ horizontal: "right", vertical: "top" }}
                        onRequestClose={this.handleRequestClose}
                        disableTouchRipple={true}
                    >
                        <Menu
                            listStyle={this.styles.list}
                            open={this.state.isMenuOpen}
                            menuItemStyle={this.styles.menuItem}
                            style={this.styles.menu}
                            desktop={true}
                        >
                            <MenuItem
                                primaryText="My Profile"
                                leftIcon={
                                    <FontIcon
                                        className="fa fa-user"
                                        style={this.styles.menuItemIcon}
                                    />
                                }
                                onTouchTap={this.onTouchTap.bind(
                                    this,
                                    this.props.onMyAccountClick
                                )}
                            />
                            <MenuItem
                                primaryText="Log out"
                                leftIcon={
                                    <FontIcon
                                        className="fa fa-sign-out"
                                        style={this.styles.menuItemIcon}
                                    />
                                }
                                onTouchTap={this.onTouchTap.bind(
                                    this,
                                    this.props.logOut
                                )}
                            />
                        </Menu>
                    </Popover>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default UserAccountMenu;



// WEBPACK FOOTER //
// ./src/components/AppHeader/UserAccountMenu.js